import { onMounted, onUnmounted, watch, type Ref } from 'vue'

import { useThemeStore } from '@/store'
import { storeToRefs } from 'pinia'
import type { ECharts } from 'echarts'
import { useI18n } from 'vue-i18n'
import { debounce } from 'lodash'

//获取css变量
export const getCssVar = (name: string) => {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim()
}

// 图表自适应
export const useChartResizeListener = (myChart: Ref<ECharts | null>) => {
  const resizeCharts = debounce(() => {
    myChart.value?.resize()
  }, 200)
  onMounted(() => {
    window.addEventListener('resize', resizeCharts)
  })
  onUnmounted(() => {
    window.removeEventListener('resize', resizeCharts)
  })
}

//图标容器size观察
export const useChartSizeContentListener = (myChart: Ref<ECharts | null>, el: HTMLElement) => {
  // 观察容器尺寸变化，实时自适应宽度
  const ro = new ResizeObserver(() => {
    myChart.value?.resize()
  })
  ro.observe(el)

  // 在卸载时清理观察器
  onUnmounted(() => {
    ro.disconnect()
  })
}

// 图表主题监听
export const useChartThemeListener = (callback: () => void) => {
  const themeStore = useThemeStore()
  const { theme } = storeToRefs(themeStore)

  watch(theme, () => {
    callback()
  })
}

// 图表语言监听
export const useChartLocaleListener = (callback: () => void) => {
  const { locale } = useI18n()

  watch(locale, () => {
    callback()
  })
}
